import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import { IconAlertTriangle } from '@/components/icon/tabler/IconAlertTriangle';
import { useTranslate } from '@/state/i18n';

interface Props {
  message: string;
  onRetry: () => void;
}

/** Error state for a page whose data failed to load (design P16-D): short copy and a retry. */
const LoadErrorState = ({ message, onRetry }: Props) => {
  const t = useTranslate('components.LoadErrorState');

  return (
    <Stack role="alert" alignItems="center" textAlign="center" gap={1.5} sx={{ py: 8, px: 2 }}>
      <IconAlertTriangle color="error" sx={{ fontSize: 32 }} />
      <Typography variant="subtitle1" fontWeight={600}>
        {message}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('hint')}
      </Typography>
      <Button variant="outlined" size="small" onClick={onRetry}>
        {t('retry')}
      </Button>
    </Stack>
  );
};

export default LoadErrorState;
